const stickyNav = {

	$window: $(window),
	supports: 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window  && 'intersectionRatio' in window.IntersectionObserverEntry.prototype,
	obsOpt: {
		rootMargin: '0px',
		threshold: 1.0
	},

	elem: {
		$nav: $('.sticky-nav')
	},

	init() {
		if (this.supports) {
			let observer = new IntersectionObserver(this.toggleSticky, this.obsOpt);

			this.elem.$nav.each(function() {
				observer.observe($(this)[0]);
			});
		}
	},

	toggleSticky(entries) {
		entries.forEach((entry) => {
		  if (!entry.isIntersecting) {
		    $(entry.target).addClass('pinned');
		  } else {
		    $(entry.target).removeClass('pinned');
		  }
		});
	},

	bindUIActions() {}
};

export { stickyNav };
